module.exports = __webpack_public_path__ + "img/bgImg.99ec4da7.png";